/* eslint-env browser, es6 */
import m from "mithril";

import {
  GameStateDuelChallenge1,
  GameStateDuelChallenge2,
} from "../game-state";
import { EmptyBoardView } from "./board";
import { ButtonView } from "./button";
import { GameController } from "../game-controller";
import { FooterView, HeaderView } from "./header-footer";
import { NicknameInputView } from "./input";

interface GameDuelChallenge1ViewAttrs {
  state: GameStateDuelChallenge1;
}

export class GameDuelChallenge1View
  implements m.Component<GameDuelChallenge1ViewAttrs>
{
  private state: GameStateDuelChallenge1;

  constructor(vnode: m.Vnode<GameDuelChallenge1ViewAttrs>) {
    this.state = vnode.attrs.state;
  }

  view(): m.Children {
    return [
      m(HeaderView),
      m("p.challenged", [
        "You have been challenged to a game of ",
        m("strong", "Webble"),
        " by ",
        m("strong", this.state.duel.creatorNickname),
        "!",
      ]),
      m(ButtonView, {
        message: "Accept",
        hookOnClick: GameController.acceptDuel,
      }),
      m(FooterView),
    ];
  }
}

interface GameDuelChallenge2ViewAttrs {
  state: GameStateDuelChallenge2;
}

export class GameDuelChallenge2View
  implements m.Component<GameDuelChallenge2ViewAttrs>
{
  private state: GameStateDuelChallenge2;
  private nicknameInputIsValid: boolean;

  constructor(vnode: m.Vnode<GameDuelChallenge2ViewAttrs>) {
    this.state = vnode.attrs.state;
    this.nicknameInputIsValid = true;
  }

  view(): m.Children {
    return [
      m(HeaderView),
      m(EmptyBoardView),
      m(NicknameInputView, {
        hookOnInput: (value: string, isValid: boolean) => {
          this.state.nickname = value;
          this.nicknameInputIsValid = isValid;
        },
        initialValue: this.state.nickname,
      }),
      m(ButtonView, {
        message: "Start duel",
        disabled: !this.state.nickname || !this.nicknameInputIsValid,
        hookOnClick: () =>
          GameController.startDuel(this.state.duel, this.state.nickname),
      }),
      m(FooterView),
    ];
  }
}
